import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS
import "../../css/app2.css";
import logo from '../../images/tiutLogo.png';
import logoW from '../../images/tiutLogoW.png';
import df from "../../images/Default_pfp.jpg";
// Icons
import { 
  FaLinkedin, 
  FaTwitter, 
  FaInstagram, 
  FaGlobe, 
  FaMapMarkedAlt, 
  FaBriefcase, 
  FaRocket, 
  FaBolt, 
  FaArrowRight, 
  FaBars, 
  FaTimes,
  FaUsers,
  FaGraduationCap,
  FaAward
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const defaultCommitteeMembers = [
  {
    name: "Dr. Sujit Mukherjee",
    role: "Patron / Vice Chancellor",
    designation: "Patron / Vice Chancellor",
    department: "Techno India University, Tripura",
    image: null,
  },
  {
    name: "Prof. (Dr.) A. K. Saha",
    role: "Chairperson, Alumni Cell",
    designation: "Chairperson, Alumni Cell",
    department: "Dean of Academic Affairs, TIUT",
    image: null,
  },
  {
    name: "Nilanjan Tiut",
    role: "Coordinator, Alumni Cell",
    designation: "Coordinator, Alumni Cell",
    department: "Faculty / Alumni Coordinator, TIUT",
    image: null,
  },
  {
    name: "Dr. R. Bhattacharya",
    role: "Secretary",
    designation: "Secretary",
    department: "Department of CSE, TIUT",
    image: null,
  },
  {
    name: "Prof. S. Roy",
    role: "Joint Secretary",
    designation: "Joint Secretary",
    department: "Department of Management, TIUT",
    image: null,
  },
  {
    name: "Alumni Representative",
    role: "Executive Member",
    designation: "Executive Member",
    department: "Alumni Association, TIUT",
    image: null,
  },
];

const Landing = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [committeeMembers, setCommitteeMembers] = useState(defaultCommitteeMembers);
  const [loadingMembers, setLoadingMembers] = useState(true);

  // Initialize AOS Animation & Fetch Committee Members
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out-cubic',
      once: true,
      offset: 100,
    });

    fetch('/api/open/committee-members')
      .then((res) => res.json())
      .then((data) => {
        setLoadingMembers(false);
        if (data && data.data && data.data.length > 0) {
          setCommitteeMembers(data.data);
        } else {
          // If empty array explicitly returned from database
          setCommitteeMembers([]);
        }
      })
      .catch((err) => {
        console.error('Error fetching committee members:', err);
        setLoadingMembers(false);
        // Retain default members if API fails or is offline
      });
  }, []);

  return (
    <div className="App">
      
      {/* --- Navigation --- */}
      <nav className="navbar navbar-expand-lg fixed-top navbar-glass">
        <div className="container">
          <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
            <img src={logo} alt="TIUT Alumni Logo" style={{ height: '75px' }} />
          </Link>
          
          <button className="navbar-toggler border-0" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
             {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          <div className={`collapse navbar-collapse ${mobileMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 text-center">
              <li className="nav-item">
                <a className="nav-link-custom" href="#about" onClick={() => setMobileMenuOpen(false)}>About TIUT Alumni</a>
              </li>
              <li className="nav-item">
                <a className="nav-link-custom" href="#committee" onClick={() => setMobileMenuOpen(false)}>Committee Members</a>
              </li>
              <li className="nav-item">
                <a className="nav-link-custom" href="#impact" onClick={() => setMobileMenuOpen(false)}>Impact</a>
              </li>
            </ul>
            <div className="d-flex gap-3 justify-content-center mt-3 mt-lg-0">
              <Link to="/login" className="btn btn-brand">Login</Link>
              <Link to="/login" className="btn btn-brand">Join Network</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* --- Hero Section --- */}
      <section className="hero-section text-center" id="home">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div data-aos="fade-down">
                <span className="badge bg-dark rounded-pill px-3 py-2 mb-3 text-uppercase" style={{ letterSpacing: '1px', color: '#E42026' }}>
                  <FaBolt className="me-2" /> Official Alumni Network
                </span>
              </div>
              <h1 className="display-3 fw-bold mb-4" data-aos="fade-up" data-aos-delay="200">
                Reconnect with your <br />
                <span className="text-highlight">Your TIUT Family is just a click away.</span>
              </h1>
              <p className="lead text-muted mb-5 px-lg-5" data-aos="fade-up" data-aos-delay="400">
               Join a thriving global community of graduates. Reconnect with batchmates, grow your professional network, and explore new opportunities—all within your university’s official alumni platform.
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap" data-aos="fade-up" data-aos-delay="600">
                <Link to="/login" className="btn btn-brand btn-lg d-flex align-items-center gap-2">
                  Let's Connect <FaArrowRight />
                </Link>
                <Link to="/login" className="btn btn-outline-dark rounded-pill px-4 py-3 fw-bold">
                  Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- About TIUT Alumni Section --- */}
      <section className="py-5 bg-light" id="about">
        <div className="container py-5">
          <div className="row justify-content-center mb-4">
            <div className="col-lg-10" data-aos="fade-up">
              <div className="text-center mb-5">
                <span className="badge rounded-pill px-3 py-2 mb-2 text-uppercase fw-bold" style={{ backgroundColor: 'rgba(228, 32, 38, 0.1)', color: '#E42026' }}>
                  About Us
                </span>
                <h2 className="display-5 fw-bold text-dark">Alumni Cell – Techno India University, Tripura (TIUT)</h2>
                <div className="mx-auto mt-3" style={{ width: '80px', height: '4px', backgroundColor: '#E42026', borderRadius: '2px' }}></div>
              </div>

              <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 bg-white mb-4">
                <p className="lead text-secondary mb-4" style={{ lineHeight: '1.8' }}>
                  The Alumni Cell of Techno India University, Tripura (TIUT), aims to strengthen the relationship between the University and its alumni by fostering lifelong connections, professional networking, and institutional development. The Cell facilitates communication between alumni, current students, faculty members, and the University to promote knowledge sharing, career guidance, mentorship, and collaborative opportunities.
                </p>
                <p className="text-muted mb-4" style={{ lineHeight: '1.8', fontSize: '1.05rem' }}>
                  The Alumni Cell works towards establishing a strong alumni network and maintaining an updated database of graduates, including their academic achievements, professional accomplishments, higher education pursuits, and career developments. It encourages alumni to participate in various academic and institutional activities, including seminars, conferences, webinars, workshops, placement initiatives, guest lectures, and student mentoring programmes. The Cell also promotes interaction through digital platforms, email, and social media groups to keep alumni informed about the University's latest initiatives, achievements, events, and developments.
                </p>
                <p className="text-muted mb-0" style={{ lineHeight: '1.8', fontSize: '1.05rem' }}>
                  In alignment with the vision of the National Education Policy (NEP) 2020 and the objectives of higher education, the Alumni Cell seeks to engage former students in the University's academic, research, innovation, entrepreneurship, and community development initiatives. Through alumni interactions, networking events, reunions, and collaborative programmes, the Cell aims to build a mutually beneficial relationship between the University and its graduates. These initiatives are intended to strengthen institutional identity, encourage alumni contributions to the University's growth, and inspire current students through the experiences and achievements of former students.
                </p>
              </div>

              {/* Highlight Pillars */}
              <div className="row g-4 mt-2">
                <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                  <div className="p-4 bg-white rounded-4 shadow-sm h-100 border-start border-4" style={{ borderColor: '#E42026' }}>
                    <div className="d-flex align-items-center mb-3">
                      <div className="rounded-circle p-2 me-3" style={{ backgroundColor: 'rgba(228, 32, 38, 0.1)', color: '#E42026' }}>
                        <FaUsers size={22} />
                      </div>
                      <h5 className="fw-bold text-dark mb-0">Lifelong Network</h5>
                    </div>
                    <p className="text-muted small mb-0">Fostering lasting connections, mentorship, and professional collaboration between alumni, faculty, and students.</p>
                  </div>
                </div>
                <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                  <div className="p-4 bg-white rounded-4 shadow-sm h-100 border-start border-4" style={{ borderColor: '#E42026' }}>
                    <div className="d-flex align-items-center mb-3">
                      <div className="rounded-circle p-2 me-3" style={{ backgroundColor: 'rgba(228, 32, 38, 0.1)', color: '#E42026' }}>
                        <FaAward size={22} />
                      </div>
                      <h5 className="fw-bold text-dark mb-0">Institutional Growth</h5>
                    </div>
                    <p className="text-muted small mb-0">Active engagement in seminars, workshops, placement initiatives, guest lectures, and webinars.</p>
                  </div>
                </div>
                <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
                  <div className="p-4 bg-white rounded-4 shadow-sm h-100 border-start border-4" style={{ borderColor: '#E42026' }}>
                    <div className="d-flex align-items-center mb-3">
                      <div className="rounded-circle p-2 me-3" style={{ backgroundColor: 'rgba(228, 32, 38, 0.1)', color: '#E42026' }}>
                        <FaGraduationCap size={22} />
                      </div>
                      <h5 className="fw-bold text-dark mb-0">NEP 2020 Vision</h5>
                    </div>
                    <p className="text-muted small mb-0">Driving innovation, research, entrepreneurship, and community development alongside former students.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Committee Members Section --- */}
      <section className="py-5 bg-white" id="committee">
        <div className="container py-5">
          <div className="row align-items-end mb-5 text-center">
            <div className="col-lg-8 mx-auto" data-aos="fade-up">
              <span className="badge rounded-pill px-3 py-2 mb-2 text-uppercase fw-bold" style={{ backgroundColor: 'rgba(228, 32, 38, 0.1)', color: '#E42026' }}>
                Leadership & Governance
              </span>
              <h2 className="display-5 fw-bold text-dark">Alumni Committee Members</h2>
              <p className="lead text-muted">Dedicated individuals guiding the vision, engagement, and initiatives of the TIUT Alumni Cell.</p>
              <div className="mx-auto mt-3" style={{ width: '80px', height: '4px', backgroundColor: '#E42026', borderRadius: '2px' }}></div>
            </div>
          </div>

          {loadingMembers && committeeMembers.length === 0 ? (
            <div className="text-center py-5">
              <div className="spinner-border text-danger" role="status"></div>
              <p className="mt-3 text-muted small mb-0">Loading committee members...</p>
            </div>
          ) : committeeMembers.length === 0 ? (
            <div className="text-center py-5" data-aos="fade-up">
              <div className="rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3" style={{ backgroundColor: 'rgba(228, 32, 38, 0.08)', color: '#E42026' }}>
                <FaAward size={36} />
              </div>
              <h4 className="fw-bold text-dark mb-2">Committee Details Will Be Updated Soon</h4>
              <p className="text-muted small mb-0">The list of alumni committee members is currently being finalized.</p>
            </div>
          ) : (
            <div className="row g-4">
              {committeeMembers.map((member, index) => (
                <div key={member.id || index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={index * 100}>
                  <div className="card p-4 committee-card h-100 text-center">
                    <div className="mb-3 position-relative d-inline-block mx-auto">
                      <img 
                        src={member.image || df} 
                        alt={member.name} 
                        className="rounded-circle shadow-sm" 
                        style={{ width: '85px', height: '85px', objectFit: 'cover', border: '3px solid #E42026' }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = df;
                        }} 
                      />
                    </div>
                    <h5 className="mb-1 fw-bold text-dark">{member.name}</h5>
                    <div className="mb-2">
                      <span 
                        className="badge rounded-pill px-3 py-1 fw-semibold small" 
                        style={{ backgroundColor: 'rgba(228, 32, 38, 0.1)', color: '#E42026' }}
                      >
                        {member.designation || member.role}
                      </span>
                    </div>
                    <p className="text-muted small mb-0">{member.department || 'TIUT'}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* --- Stats / Impact Section --- */}
      <section className="py-5 bg-light" id="impact">
        <div className="container my-5">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-5 mb-lg-0" data-aos="fade-right">
              <span className="badge rounded-pill px-3 py-2 mb-2 text-uppercase fw-bold" style={{ backgroundColor: 'rgba(228, 32, 38, 0.1)', color: '#E42026' }}>
                Connect & Grow
              </span>
              <h2 className="display-5 fw-bold mb-4">Why join the network?</h2>
              <p className="lead text-muted mb-4">
                Stop guessing. Start connecting. Our intelligent directory sorts alumni by industry, location, and willingness to mentor.
              </p>
              
              <div className="d-flex align-items-start mb-4">
                <div className="rounded-circle p-3 me-3 text-white d-flex align-items-center justify-content-center" style={{ backgroundColor: '#E42026', width: '50px', height: '50px' }}>
                  <FaMapMarkedAlt size={22} />
                </div>
                <div>
                  <h5 className="fw-bold text-dark">Intelligent Alumni Directory</h5>
                  <p className="text-muted mb-0">Find people who matter. Our smart directory filters alumni by industry, location, skills, and mentorship interest—so you always connect with the right person.</p>
                </div>
              </div>
              
              <div className="d-flex align-items-start">
                <div className="rounded-circle p-3 me-3 text-white d-flex align-items-center justify-content-center" style={{ backgroundColor: '#E42026', width: '50px', height: '50px' }}>
                  <FaBriefcase size={22} />
                </div>
                <div>
                  <h5 className="fw-bold text-dark">Hidden Job Market</h5>
                  <p className="text-muted mb-0">Access opportunities you won't find anywhere else. Explore jobs and internships posted exclusively by TIUT alumni.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 offset-lg-1">
              <div className="row g-3">
                <div className="col-12" data-aos="zoom-in" data-aos-delay="400">
                  <div className="p-5 stats-box highlight text-center">
                    <div className="d-flex justify-content-center align-items-center mb-2">
                      <FaRocket size={36} className="me-3 text-white" />
                      <h2 className="display-4 fw-bold mb-0 text-white">24k+</h2>
                    </div>
                    <small className="text-white fw-bold text-uppercase fs-6">Alumni Network</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Footer --- */}
      <footer className="py-5" style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-5">
              <div className="d-flex align-items-center gap-2 mb-3">
                <img src={logoW} style={{ height: '75px', maxWidth: '280px', objectFit: 'contain' }} alt="TIUT Alumni Logo" />
              </div>
              <p className="small pe-lg-4">Building the bridge between past, present, and future at Techno India University, Tripura.</p>
            </div>
            <div className="col-lg-3">
              <h6 className="fw-bold text-white mb-3">Useful Links</h6>
              <ul className="list-unstyled small">
                <li className="mb-2"><a href="https://tiut.ac.in" target="_blank" rel="noreferrer" className="text-decoration-none text-reset">Techno India University, Tripura</a></li>
                <li className="mb-2"><a href="#about" className="text-decoration-none text-reset">About TIUT Alumni</a></li>
                <li className="mb-2"><a href="#committee" className="text-decoration-none text-reset">Committee Members</a></li>
                <li className="mb-2"><a href="#impact" className="text-decoration-none text-reset">Network Impact</a></li>
              </ul>
            </div>
           
            <div className="col-lg-4">
              <h6 className="fw-bold text-white mb-3">Stay Connected</h6>
              <div className="d-flex gap-3 mb-3">
                <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-white"><FaTwitter className="fs-4" /></a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-white"><FaLinkedin className="fs-4" /></a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-white"><FaInstagram className="fs-4" /></a>
                <a href="https://tiut.ac.in" target="_blank" rel="noreferrer" className="text-white"><FaGlobe className="fs-4" /></a>
              </div>
              <p className="small mb-0">Techno India University, Tripura<br />Maheshkhala, Anandanagar, Tripura 799004</p>
            </div>
          </div>
          <div className="text-center pt-4 mt-4 border-top border-secondary border-opacity-25">
            <small>&copy; {new Date().getFullYear()} Alumni Cell – Techno India University, Tripura (TIUT). All rights reserved.</small>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
